export default function IconSyncArrowClock({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0.53 0.7 16.95 16.95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M10.0546 16.0291C11.4101 16.0291 12.7351 15.6272 13.8622 14.8741C14.9892 14.1211 15.8676 13.0507 16.3864 11.7984C16.9051 10.5461 17.0408 9.1681 16.7764 7.83867C16.5119 6.50923 15.8592 5.28806 14.9007 4.32959C13.9423 3.37112 12.7211 2.7184 11.3916 2.45396C10.0622 2.18951 8.68421 2.32524 7.43191 2.84396C6.17961 3.36268 5.10925 4.2411 4.35618 5.36814C3.60312 6.49518 3.20117 7.82022 3.20117 9.17571V9.70289"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.0918 7.5918L3.20055 9.70055L5.3093 7.5918"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.52734 4.95605V9.70074H13.2177"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
